// Provisional usability caps, mirrored by the API in tables/export/limits.py.
export const WORD_MAX_ROWS = 100
export const WORD_MAX_CELLS = 10_000
export const WORD_MAX_COLUMNS = 10
export const WORD_TOO_LARGE = 'This table is too large for Word.'

export function wordTooLarge(rows: number | null | undefined, columns: number | null): boolean {
  return (
    (rows != null && rows > WORD_MAX_ROWS) ||
    (columns != null && columns > WORD_MAX_COLUMNS) ||
    (rows != null && columns != null && rows * columns > WORD_MAX_CELLS)
  )
}
